import {
	BagAgenciesResponse,
	BagCurrenciesResponse,
	BagOrganizationsResponse,
	BagPaymentOrganization,
	BagPaymentTermAmountResponse,
	BagPaymentTermCurrency,
	BagPaymentTermProduct,
	BagPaymentTermResponse,
	BagProductsResponse,
} from '@/bag/bag-payment-term-list/bag-payment-term-list.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class BagPaymentTermListApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getCurrencies(queryParams: string): Observable<BagPaymentTermCurrency[]> {
		return this.httpClient
			.get<BagCurrenciesResponse>(`${this.apiUrl}/currency/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getOrganizations(queryParams: string): Observable<BagPaymentOrganization[]> {
		return this.httpClient
			.get<BagOrganizationsResponse>(`${this.apiUrl}/organization/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getAgencies(queryParams: string): Observable<BagPaymentOrganization[]> {
		return this.httpClient
			.get<BagAgenciesResponse>(`${this.apiUrl}/organization/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getProducts(queryParams: string): Observable<BagPaymentTermProduct[]> {
		return this.httpClient
			.get<BagProductsResponse>(`${this.apiUrl}/product/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getPaymentTerms(params: string): Observable<BagPaymentTermResponse> {
		return this.httpClient.get<BagPaymentTermResponse>(`${this.apiUrl}/reservation/payment_term/?${params}`);
	}

	getPaymentTermsAmount(params: string): Observable<BagPaymentTermAmountResponse> {
		return this.httpClient.get<BagPaymentTermAmountResponse>(
			`${this.apiUrl}/reservation/payment_term/amount/?${params}`,
		);
	}

	getPaymentTermsCsv(params: string): Observable<Blob> {
		return this.httpClient.get(`${this.apiUrl}/reservation/payment_term/csv/?${params}`, {
			responseType: 'blob',
		});
	}

	createRefundPayment(payload: Record<string, unknown>[]): Observable<unknown> {
		return this.httpClient.post(`${this.apiUrl}/payment/`, payload);
	}
}
